import React from 'react';
import styled from 'styled-components';
import stc from 'string-to-color';
// import Default from './Default';
// import { getNftOwnerPublically } from '../../services/chime';
import { supportednfts } from '../../lib/supportednfts';
import './style.scss';
// import { isEmptyObject } from 'jquery';


const Basic = ({ authorPrincipal, basic }) => {
    const principal = authorPrincipal;
    const clean = principal.slice(2);
    const raw_ringcolor = clean.substring(0, 6);
    const ringcolor = stc(raw_ringcolor);
    const DeruptarRing = styled('svg')(() => ({
        zIndex: '9',
        width: '284px',
        height: '284px',
        position: 'absolute',
        top: '0',
        left: '0',
        circle: {
            fill: 'none',
            stroke: `${ringcolor}`,
            strokeLinecap: 'round',
            strokeMiterlimit: '10',
            strokeWidth: '11px',
        }
    }));

    const { contract, id } = basic;
    const { imagehostprefix, imagehostsuffix } = supportednfts[contract];
    const shouldRenderDeruptarRing = !contract.includes('deruptars') && !contract.includes('bitcoin-beagle');
    const imageUrl = `${imagehostprefix}${id}${imagehostsuffix}`;

    return (
        <div id="basicAvatarContainer">
            {/* basic avatar content */}
            <img id="basicNFT" src={imageUrl} alt="" />
            {/* Conditionally render DeruptarRing */}
            {shouldRenderDeruptarRing && (
                <DeruptarRing xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46">
                    <circle id="_0" cx="142" cy="142" r="136.5" />
                </DeruptarRing>
            )}
        </div>
    )
};

export default Basic;